module.exports = __webpack_public_path__ + "static/media/063-japan.0e4b2b3e.svg";